import { formatBusinessDate, getBusinessDateKey } from "@/shared/utils/formatters";
import type { CalendarEvent } from "../types/calendarEventTypes";

type CalendarEventDateTimeProps = Pick<CalendarEvent, "startAt" | "endAt" | "isAllDay" | "timezone">;

export function CalendarEventDateTime({ startAt, endAt, isAllDay, timezone }: CalendarEventDateTimeProps) {
  const displayEnd = isAllDay ? new Date(endAt.getTime() - 1) : endAt;
  const sameDay = getBusinessDateKey(startAt, timezone) === getBusinessDateKey(displayEnd, timezone);
  const dateOptions: Intl.DateTimeFormatOptions = { weekday: "short", day: "numeric", month: "short", year: "numeric" };
  const timeOptions: Intl.DateTimeFormatOptions = { hour: "numeric", minute: "2-digit" };

  return (
    <span className="block">
      {formatBusinessDate(startAt, timezone, dateOptions)}
      {!sameDay && <> &ndash; {formatBusinessDate(displayEnd, timezone, dateOptions)}</>}
      <span className="mt-1 block text-xs font-normal text-muted-foreground">
        {isAllDay ? "All day" : <>{formatBusinessDate(startAt, timezone, timeOptions)} &ndash; {formatBusinessDate(endAt, timezone, timeOptions)} &middot; {Math.round((endAt.getTime() - startAt.getTime()) / 60_000)} min</>}
      </span>
    </span>
  );
}
